import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    height: 48px;
    min-height: 48px;
    width: calc(100% - 32px);
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    margin: 0 auto 16px;
    justify-content: center;
`;

export const NavItems = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: ${props => props.theme.widths.containerMaxWidth};

    @media (max-width: ${props => props.theme.widths.containerMaxWidth}) {
        max-width: 100%;
    }
`;

export const LoginButton = styled.div`
    cursor: pointer;
`;

export const EmptyHome = styled.div`
    width: 24px;
`;

export const Logo = styled.img``;
